import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
const RING_CAP = 10_000;
const DEFAULT_FLUSH_INTERVAL_MS = 2000;
export function createDebugStore(deps) {
    const store = createStore()(() => ({
        recent: [],
        flushActive: false,
    }));
    const pending = [];
    let flushHandle = null;
    function appendToRing(entry) {
        const current = store.getState().recent;
        const next = current.length >= RING_CAP
            ? [...current.slice(current.length - RING_CAP + 1), entry]
            : [...current, entry];
        store.setState({ recent: Object.freeze(next) });
    }
    const actions = {
        append(entry) {
            appendToRing(entry);
            pending.push(entry);
        },
        clear() {
            store.setState({ recent: Object.freeze([]) });
        },
        startFlush(intervalMs = DEFAULT_FLUSH_INTERVAL_MS) {
            if (flushHandle !== null)
                return;
            flushHandle = deps.logRepo.startAutoFlush(intervalMs, () => {
                const drained = [...pending];
                pending.length = 0;
                return drained;
            });
            store.setState({ flushActive: true });
        },
        stopFlush() {
            if (flushHandle === null)
                return;
            flushHandle.stop();
            flushHandle = null;
            store.setState({ flushActive: false });
        },
        async listStored(limit) {
            return deps.logRepo.listRecent(limit);
        },
        async clearStored() {
            return deps.logRepo.clear();
        },
    };
    const internal = {
        _appendLocal(entry) {
            appendToRing(entry);
            pending.push(entry);
        },
    };
    return { store, actions, internal };
}
export function useDebugStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=debug-store.js.map